import React from 'react'

function SignupModal() {
  return (
    <div
      className="modal fade popup "
      id="popup_bid2"
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
      style={{ maxHeight: "90vh", marginTop: "auto", marginBottom: "auto" }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content ">
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="modal-body space-y-20 pd-40 style2">
            <div className="wrap-modal flex">
              <div
                className="images flex-none relative"
                style={{ overflow: "auto", maxHeight: "90vh" }}
              >
                <img src="/assets/images/section/bg-register.jpg" alt="images" />
                <div className="mark-logo">
                  <img src="/assets/images/logo/logo2.png" alt="images" />
                </div>
              </div>
              <div
                className="content"
                style={{ overflow: "auto", maxHeight: "90vh" }}
              >
                <div className="title-login fs-30 fw-7 lh-45">Inscription</div>
                <div className="comments">
                  <div className="respond-comment">
                    <form
                      method="post"
                      className="comment-form form-submit"
                      action="#"
                      acceptCharset="utf-8"
                      noValidate="noValidate"
                    >
                      <fieldset className="">
                        <label className="fw-6">Nom d'utilisateur</label>
                        <input
                          type="text"
                          className="tb-my-input"
                          name="text"
                          placeholder="Nom d'utilisateur"
                        />
                        <img
                          className="img-icon img-name"
                          src="/assets/images/icon/login-user.svg"
                          alt="images"
                        />
                      </fieldset>
                      <fieldset className="">
                        <label className="fw-6">Email</label>
                        <input
                          type="email"
                          className="tb-my-input"
                          name="email"
                          placeholder="Email"
                        />
                        <img
                          className="img-icon"
                          src="/assets/images/icon/icon-gmail.svg"
                          alt="images"
                        />
                      </fieldset>
                      <fieldset className="">
                        <label className="fw-6">Mot de passe</label>
                        <input
                          type="password"
                          className="input-form password-input"
                          placeholder="Mot de passe"
                        />
                        <img
                          className="img-icon"
                          src="/assets/images/icon/icon-password.svg"
                          alt="images"
                        />
                      </fieldset>
                      <fieldset className="">
                        <label className="fw-6">Confirmer mot de passe</label>
                        <input
                          type="password"
                          className="input-form password-input"
                          placeholder="Confirmation du mot de passe"
                        />
                        <img
                          className="img-icon"
                          src="/assets/images/icon/icon-password.svg"
                          alt="images"
                        />
                      </fieldset>
                      <button className="sc-button" name="submit" type="submit">
                        <span>S'inscrire</span>
                      </button>
                    </form>
                  </div>
                </div>
                <div className="text-box text-center fs-13">
                  Vous avez déjà un compte?{" "}
                  <a
                    className="font-2 fw-7 fs-13 color-popup text-color-3"
                    data-toggle="modal"
                    data-target="#popup_bid"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    Connectez-vous
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignupModal